export enum CalibrationType {
  LPR = 'LPR',
  NIGHTLPR = 'NIGHTLPR',
  MAP = 'MAP',
}

export type CalibrationPoint = [number, [number, number, number?]]; // [point index, [x, y, z = 0]]

export interface XyPoint {
  x: number;
  y: number;
}

export type MapPoint = [number, google.maps.LatLng]; // [point index, [lat, long]] ->

export interface HomographyImage {
  name: string;
  points: CalibrationPoint[];
}

export interface ImagePairs {
  imageOne: HomographyImage;
  imageTwo: HomographyImage;
}

export interface CalibrationPairs {
  calibrationType: CalibrationType;
  imagePairs: ImagePairs;
}

export interface HomographyRequest {
  deviceId: string;
  imagePairs: CalibrationPairs[];
}

export interface HomographyMatrixPair {
  calibrationType: CalibrationType;
  transformMatrix: Float32Array;
}

export interface CalculateHomographyResponse {
  transformMatrices: HomographyMatrixPair[];
}
